class BodyFactory {
  createMultipartBody(files, name = "files", other) {
    const formData = new FormData();

    if (files !== null && files.length > 0) {
      for (let i = 0; i < files.length; i++) {
        formData.append(name, files[i]);
      }
    }

    if (other !== undefined) {
      Object.keys(other).forEach(function (key, index) {
        formData.append(
          key,
          new Blob([JSON.stringify(other[key])], {
            type: "application/json"
          })
        );
      });
    }

    return formData;
  }
}

export default BodyFactory;
